import * as R from 'ramda'

export const OrderStatusText = {
  CLOSED: '已关闭',
  ERROR: '错误',
  REFUNDING: '退款中',
  REFUND: '已退款',
  SUCCESS: '支付成功',
  TO_BE_PAID: '待支付',
  PAID: '已支付'
}

export const RefundWayText = {
  OFFLINE_REFUND: '线下退款',
  WEIXIN_REFUND: '线上支付微信退款'
}

export function refundKey () {
  return R.keys(RefundWayText)
}

export function refundOptions () {
  return R.values(RefundWayText)
}

export function statusCodes () {
  return R.keys(OrderStatusText)
}
export function statusOptions () {
  return R.values(OrderStatusText)
}
